export default __webpack_public_path__ + "static/media/Qe_14.50ec4e37.JPG";